import { createRouter, createWebHashHistory } from "vue-router";
//import { authAdmin, authUser, requestToken } from "@/helpers/AuthRouter";
import store from "@/store";

import LandingView from "@/views/LandingView.vue";
import ActivityView from "@/views/ActivityView";
import AdminView from "@/views/AdminView";
import ResourcesView from "@/views/ResourcesView";
/*
 * All routes should be lowercase.
 */
const routes = [
  {
    path: store.getters.useLandingPage ? "/" : "/landing",
    name: "Landing",
    component: LandingView,
    beforeEnter: store.getters.useAuth ? authUser : null
  },
  {
    path: store.getters.useLandingPage ? "/activity" : "/",
    name: "Activity",
    component: ActivityView,
    beforeEnter: store.getters.useAuth ? authUser : null
  },
  {
    path: "/resources",
    name: "Resources",
    component: ResourcesView,
    beforeEnter: store.getters.useAuth ? authUser : null
  },

  {
    path: "/admin",
    name: "Admin",
    component: AdminView,
    beforeEnter: [authUser, authAdmin]
  }
];

function authAdmin(_to, _from, next) {
  if (!store.getters.isAdmin) {
    console.warn("NOT ADMIN");
    return;
  }
  next();
}

function authUser(to, _from, next) {
  if (!store.getters.useAuth) {
    console.warn("No Auth");
    return;
  }

  if (!store.getters.publicKey) {
    console.warn("No Public Key");
    return;
  }

  if (to.query) {
    if (to.query.jwt) {
      store.dispatch("setToken", to.query.jwt);
      delete to.query.jwt;
      router.replace(to);
    }
  }

  if (store.getters.getToken) {
    if (store.getters.isAuthenticated) {
      next();
    } else {
      requestToken();
    }
  } else {
    requestToken();
  }
}

function requestToken() {
  let originalQuery =
    window.location.href.split("?").length > 1
      ? window.location.href.split("?")[1]
      : "";

  // Redirect the user back to the current page
  const redirect = window.location.href.split("?")[0];

  // Create the params needed by the auth endpoint
  const params = {
    public_key: store.getters.publicKey,
    query: originalQuery,
    redirect: redirect
  };

  const query = new URLSearchParams(Object.entries(params));
  query.toString();

  // Redirect the user to the auth endpoint

  window.location.href =
    `https://courses.ecampus.oregonstate.edu/services/auth/public/v1/token` +
    "?" +
    query;
}

/*
 *
 * https://router.vuejs.org/guide/essentials/history-mode.html#hash-mode
 *
 * We use hash mode (createWebHashHistory), instead of
 * html5 mode (createWebHistory) so that it works on our S3 deployments.
 * The html5 mode is more SEO-friendly, but that isn't a concern with our
 * applications.
 */
/*
 * The 'linkExactActiveClass' is intended to style any router-view which
 * connects to the active view with the bold. It primarily will appear
 * in the `navbar`, but it will also bold any router-views, including buttons.
 */
const router = createRouter({
  mode: "history",
  linkExactActiveClass: "fw-bold",
  history: createWebHashHistory(process.env.BASE_URL),
  routes
});

export default router;
